import { createContext } from "react";

export interface FontSizeContextValue {
	fontSize: string;
	setFontSize: (fontSize: string) => void;
	fontSizeClass: string;
	fontSizeNormalClass: string;
	fontSizeBoldClass: string;
	fontSizeDeepClass: string;
	modalTextFontSizeClass: string;
	modalHeaderFontSizeClass: string;
	modalTitleFontSizeClass: string;
	fontSizes: string;
	getFontSizeClass: (diff: number) => string;
}

export const FontSizeContext = createContext<FontSizeContextValue>(
	{} as FontSizeContextValue,
);
